/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { LocalDate } from "@freightsimple/time/branded-types";

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface TeamMemberSummary
 */
export interface TeamMemberSummary {
  /**
   *
   * @type {string}
   * @memberof TeamMemberSummary
   */
  teamMemberId: string;
  /**
   *
   * @type {string}
   * @memberof TeamMemberSummary
   */
  email: string;
  /**
   *
   * @type {string}
   * @memberof TeamMemberSummary
   */
  firstName: string;
  /**
   *
   * @type {string}
   * @memberof TeamMemberSummary
   */
  lastName: string;
  /**
   *
   * @type {number}
   * @memberof TeamMemberSummary
   */
  birthdayMonth?: number | null;
  /**
   *
   * @type {number}
   * @memberof TeamMemberSummary
   */
  birthdayDay?: number | null;
  /**
   *
   * @type {LocalDate}
   * @memberof TeamMemberSummary
   */
  joinDate?: LocalDate | null;
  /**
   *
   * @type {LocalDate}
   * @memberof TeamMemberSummary
   */
  endDate?: LocalDate | null;
  /**
   *
   * @type {Array<string>}
   * @memberof TeamMemberSummary
   */
  permissions: Array<string>;
}

/**
 * Check if a given object implements the TeamMemberSummary interface.
 */
export function instanceOfTeamMemberSummary(
  value: object,
): value is TeamMemberSummary {
  if (!("teamMemberId" in value) || value["teamMemberId"] === undefined)
    return false;
  if (!("email" in value) || value["email"] === undefined) return false;
  if (!("firstName" in value) || value["firstName"] === undefined) return false;
  if (!("lastName" in value) || value["lastName"] === undefined) return false;
  if (!("permissions" in value) || value["permissions"] === undefined)
    return false;
  return true;
}

export function TeamMemberSummaryFromJSON(json: any): TeamMemberSummary {
  return TeamMemberSummaryFromJSONTyped(json, false);
}

export function TeamMemberSummaryFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): TeamMemberSummary {
  if (json == null) {
    return json;
  }
  return {
    teamMemberId: json["teamMemberId"],
    email: json["email"],
    firstName: json["firstName"],
    lastName: json["lastName"],
    birthdayMonth:
      json["birthdayMonth"] == null ? undefined : json["birthdayMonth"],
    birthdayDay: json["birthdayDay"] == null ? undefined : json["birthdayDay"],
    joinDate: json["joinDate"] == null ? undefined : json["joinDate"],
    endDate: json["endDate"] == null ? undefined : json["endDate"],
    permissions: json["permissions"],
  };
}

export function TeamMemberSummaryToJSON(json: any): TeamMemberSummary {
  return TeamMemberSummaryToJSONTyped(json, false);
}

export function TeamMemberSummaryToJSONTyped(
  value?: TeamMemberSummary | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    teamMemberId: value["teamMemberId"],
    email: value["email"],
    firstName: value["firstName"],
    lastName: value["lastName"],
    birthdayMonth: value["birthdayMonth"],
    birthdayDay: value["birthdayDay"],
    joinDate: value["joinDate"],
    endDate: value["endDate"],
    permissions: value["permissions"],
  };
}
